import { useState, useEffect } from "react";

/**
 * Хук для переключения верстки на мобильную версию
 * @param {string} breakpoint - максимальная ширина мобильной версии
 * @param {boolean} isMobile - состояние мобильной версии
 */
export const useMobile = (breakpoint = "393px") => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const mediaQuery = window.matchMedia(`(max-width: ${breakpoint})`);

    const handleMediaChange = (e) => {
      setIsMobile(e.matches);
    };

    setIsMobile(mediaQuery.matches);
    mediaQuery.addEventListener("change", handleMediaChange);

    return () => {
      mediaQuery.removeEventListener("change", handleMediaChange);
    };
  }, [breakpoint]);

  return isMobile;
};
